export function saveTenantSubscription(data = {}) {
  if (data.subscriptionExpiringSoon === true || data.subscriptionExpiringSoon === 'true') {
    localStorage.setItem('subscriptionExpiringSoon', '1')
    localStorage.setItem(
      'subscriptionDaysRemaining',
      String(data.subscriptionDaysRemaining ?? '')
    )
    localStorage.setItem('tenantExpireAt', data.expireAt || '')
  } else {
    clearTenantSubscription()
  }
}

export function clearTenantSubscription() {
  localStorage.removeItem('subscriptionExpiringSoon')
  localStorage.removeItem('subscriptionDaysRemaining')
  localStorage.removeItem('tenantExpireAt')
}

export function getTenantSubscriptionReminder() {
  if (localStorage.getItem('subscriptionExpiringSoon') !== '1') {
    return null
  }
  const days = Number(localStorage.getItem('subscriptionDaysRemaining'))
  const expireAt = localStorage.getItem('tenantExpireAt') || ''
  return {
    daysRemaining: Number.isFinite(days) ? days : null,
    expireAt,
    message: buildRenewMessage(days, expireAt),
  }
}

export function buildRenewMessage(daysRemaining, expireAt) {
  if (Number.isFinite(daysRemaining)) {
    if (daysRemaining <= 0) {
      return '租户服务已到期或即将到期，请尽快联系平台续费。'
    }
    return `租户服务将在 ${daysRemaining} 天后到期（${expireAt || '到期日未知'}），请尽快联系平台续费。`
  }
  if (expireAt) {
    return `租户服务将于 ${expireAt} 到期，请尽快联系平台续费。`
  }
  return '租户服务即将到期，请尽快联系平台续费。'
}
